import React from 'react';
import { connect } from 'react-redux';
import { Icon, NLink } from '@fttb/common/components';
import { getTariffDescription, getTariffUrl } from "../../../../store/blocks/tariffs/tariffSelectors";
var mapStateToProps = function mapStateToProps(state) {
  return {
    children: getTariffDescription(state),
    href: getTariffUrl(state),
    isNoUnderline: true,
    rightIcon: /*#__PURE__*/React.createElement(Icon, {
      name: "chevronRight",
      "data-t-id": "components-TariffLink"
    }),
    size: 'size6-r',
    variant: 'light'
  };
};
export var TariffLink = connect(mapStateToProps)(NLink);